// Activity participation-rate display helper (feature 024).
// Mirrors backend utills/participationRate.js#formatRate EXACTLY so every screen —
// server and client — renders the rate identically (spec FR-010, FR-014).
//
// Rule: nearest whole percent, except "0%" is reserved for a true zero count and a
// non-zero count that would round below 1% shows "<1%". Never divides by zero.
//
// @param {number} count  distinct users who did the activity (numerator)
// @param {number} total  total_user_count for the period + filters (denominator)
// @returns {{ pct: number, label: string, isTrueZero: boolean }}
export function formatParticipation(count, total) {
  const c = Number(count) || 0;
  const t = Number(total) || 0;

  if (t <= 0 || c <= 0) {
    return { pct: 0, label: `${c} of ${t} users (0%)`, isTrueZero: c <= 0 };
  }

  const rounded = Math.round((c / t) * 100);
  const pctText = rounded < 1 ? '<1%' : `${rounded}%`;
  return { pct: rounded, label: `${c} of ${t} users (${pctText})`, isTrueZero: false };
}
